export default __webpack_public_path__ + "static/media/ag-white.5f7170d1.svg";